import React, { useState } from 'react';

import { FormError } from '@/components/atoms/form-label';
import { Input } from '@/components/ui/input';
import { formatPhoneNumberAsYouType, normalizeUSPhoneNumber } from '@/lib/phone';
import { cn } from '@/lib/utils';

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  errors?: string[];
  className?: string;
}

export function PhoneInput({ value, onChange, placeholder = '+1 (555) 123-4567', errors, className }: PhoneInputProps) {
  const [displayValue, setDisplayValue] = useState(formatPhoneNumberAsYouType(value || ''));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setDisplayValue(inputValue);
    // Convert to E164 format when saving
    const normalizedValue = normalizeUSPhoneNumber(inputValue) || inputValue;
    onChange(normalizedValue);
  };

  const handleBlur = () => {
    setDisplayValue(formatPhoneNumberAsYouType(value || ''));
  };

  const handleFocus = () => {};

  const hasError = errors && errors.length > 0;

  return (
    <div className={cn('space-y-1.5', className)}>
      <Input
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        placeholder={placeholder}
        aria-invalid={hasError}
        className={hasError ? 'border-red-500' : ''}
      />
      <FormError errors={errors} />
    </div>
  );
}
